export const CONFIG = {
	AUTHURL: process.env.REACT_APP_AUTHURL,
	ZOOMURL: process.env.REACT_APP_ZOOMURL,
	COURSEURL: process.env.REACT_APP_COURSEURL,
	EVALUATIONURL: process.env.REACT_APP_EVALUATIONURL,
	STUDENTURL: process.env.REACT_APP_STUDENTURL,
	ANALYTICSURL: process.env.REACT_APP_ANALYTICSURL,
	SCHOOLURL : process.env.REACT_APP_SCHOOLURL,
};
